import BaseService from './BaseService'
import { api } from '@/boot/axios'
import { fixImageOrientation } from '@/utils/imageOrientation'

class EventService extends BaseService {
  constructor() {
    super('/events')
  }

  async list(params = {}) {
    // Avoid trailing-slash redirects (can become mixed-content behind proxies)
    return this.customRequest('get', '', null, { params })
  }

  async getEvent(id) {
    return this.getById(id)
  }

  async createEvent(data) {
    return this.create(data)
  }

  async updateEvent(id, data) {
    return this.update(id, data)
  }

  async deleteEvent(id) {
    return this.delete(id)
  }

  async listRegistrants(eventId, params = {}) {
    return this.customRequest('get', `/${eventId}/registrants`, null, { params })
  }

  async addRegistrant(eventId, data) {
    return this.customRequest('post', `/${eventId}/registrants`, data)
  }

  async refundRegistrant(eventId, registrantId) {
    return this.customRequest('post', `/${eventId}/registrants/${registrantId}/refund`)
  }

  async resendRegistrantEmail(eventId, registrantId, payload) {
    return this.customRequest('post', `/${eventId}/registrants/${registrantId}/email`, payload)
  }

  async createLink(eventId, data) {
    return this.customRequest('post', `/${eventId}/links`, data)
  }

  async listTicketPackages(eventId) {
    return this.customRequest('get', `/${eventId}/ticket-packages`)
  }

  async createTicketPackage(eventId, data) {
    return this.customRequest('post', `/${eventId}/ticket-packages`, data)
  }

  async updateTicketPackage(eventId, packageId, data) {
    return this.customRequest('put', `/${eventId}/ticket-packages/${packageId}`, data)
  }

  async deleteTicketPackage(eventId, packageId) {
    return this.customRequest('delete', `/${eventId}/ticket-packages/${packageId}`)
  }

  async uploadCover(eventId, file) {
    const fixedFile = await fixImageOrientation(file)
    const formData = new FormData()
    formData.append('cover', fixedFile)
    const res = await api.post(`/events/${eventId}/cover`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return res.data
  }

  async autocompleteAddress(input) {
    return this.customRequest('get', '/address/autocomplete', null, { params: { input } })
  }

  async publicShow(token) {
    const res = await api.get(`/links/events/${token}`)
    return res.data
  }

  async checkDuplicate(token, params) {
    const res = await api.get(`/links/events/${token}/registrants/check`, { params })
    return res.data
  }

  async publicRegister(token, payload) {
    const res = await api.post(`/links/events/${token}/register`, payload)
    return res.data
  }
}

export const eventService = new EventService()

